import { Link } from 'react-router-dom';
import DocumentHead from '../components/DocumentHead';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[var(--mang-bg,#FFFEFA)]">
      <DocumentHead
        title="Privacy"
        description="Informativa privacy Mangitalia: trattamento dati di clienti, produttori e iscritti newsletter."
        path="/privacy"
      />
      <div className="max-w-3xl mx-auto px-4 py-12">
        <p className="text-sm mb-6">
          <Link to="/" className="text-[#c78244] underline">← Home</Link>
        </p>
        <h1 className="text-3xl font-bold text-[#c78244] mb-4">Privacy</h1>
        <p className="text-gray-600 mb-8 leading-relaxed">
          Il trattamento dei dati personali su Mangitalia è descritto nell&apos;informativa completa
          pubblicata su Iubenda. Di seguito un riepilogo operativo per orientarti.
        </p>

        <ul className="space-y-3 text-gray-700 mb-10 list-disc pl-5">
          <li>Dati di account cliente e produttore per autenticazione e gestione ordini.</li>
          <li>Dati di candidatura e documenti per la valutazione qualità.</li>
          <li>Email newsletter / waitlist per aggiornamenti sul lancio e sulle novità del catalogo alimentare.</li>
          <li>Dati di pagamento gestiti dai provider di pagamento (non memorizzati integralmente da Mangitalia).</li>
        </ul>

        <div className="flex flex-wrap gap-3 mb-10">
          <a
            href="https://www.iubenda.com/privacy-policy/91887353"
            target="_blank"
            rel="noreferrer"
            className="mang-gradient text-white px-6 py-3 rounded-full font-bold"
          >
            Apri Privacy Policy completa
          </a>
          <a
            href="https://www.iubenda.com/privacy-policy/91887353/cookie-policy"
            target="_blank"
            rel="noreferrer"
            className="border-2 border-[#c78244] text-[#c78244] px-6 py-3 rounded-full font-bold"
          >
            Cookie Policy
          </a>
        </div>

        <p className="text-sm text-gray-500">
          <Link to="/termini" className="text-[#c78244] underline">Termini e condizioni</Link>
        </p>
      </div>
    </div>
  );
}
